/**
 * Do not edit directly
 */

export default "PHN2ZyBmaWxsPSIjMDA1ZWE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+PHBhdGggZD0iTSA3IDIgTCA3IDQ4IEwgNDMgNDggTCA0MyAxNC41OTM3NSBMIDQyLjcxODc1IDE0LjI4MTI1IEwgMzAuNzE4NzUgMi4yODEyNSBMIDMwLjQwNjI1IDIgWiBNIDkgNCBMIDI5IDQgTCAyOSAxNiBMIDQxIDE2IEwgNDEgNDYgTCA5IDQ2IFogTSAzMSA1LjQzNzUgTCAzOS41NjI1IDE0IEwgMzEgMTQgWiI+PC9wYXRoPjwvc3ZnPg==";